import { Controller } from '@hotwired/stimulus'

// Application form behaviour: list selected document names, and gate the submit
// button on the consent checkbox (server-side validation still enforces consent).
export default class extends Controller<HTMLElement> {
  static targets = ['input', 'fileList', 'consent', 'submit']

  declare readonly inputTarget: HTMLInputElement
  declare readonly fileListTarget: HTMLElement
  declare readonly hasFileListTarget: boolean
  declare readonly consentTarget: HTMLInputElement
  declare readonly submitTarget: HTMLButtonElement

  connect(): void {
    this.consentChanged()
  }

  filesSelected(): void {
    if (!this.hasFileListTarget) return
    const files = Array.from(this.inputTarget.files ?? [])
    if (files.length === 0) {
      this.fileListTarget.hidden = true
      this.fileListTarget.textContent = ''
      return
    }
    this.fileListTarget.hidden = false
    this.fileListTarget.textContent = files.map((f) => f.name).join(', ')
  }

  consentChanged(): void {
    this.submitTarget.disabled = !this.consentTarget.checked
  }
}
